import React from "react";
import { useTable } from "../../Components/useTable";

const AssignLevelUsersList = () => {
  const type = "Assign Sending Level";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "RID" },
    { id: "username", numeric: false, label: "User Name" },
    { id: "pictureUrl", numeric: false, label: "User Image" },
    { id: "diamond", numeric: false, label: "Diamonds" },
    { id: "level", numeric: false, label: "Level" },
    // { id: "isExpired", numeric: false, label: "Expired" },
    { id: "now", numeric: false, label: "Now" },
    { id: "target", numeric: false, label: "Target" },
    { id: "created_at", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default AssignLevelUsersList;
